import React from "react";
import Splash from "../assets/splash.png";
import Netflix from "../assets/netflix2.png";
import GitFinder from "../assets/gitlogo.png";
import Chatty from "../assets/chatty.png";
import News from "../assets/news.png";
import Investment from "../assets/bs.png";
import Shopping from "../assets/stiko.png";
import Owolabi from "../assets/owolabi.png";
import Banner from "../assets/banner2.jpg";
export default function Portfolio() {
    return (
        <div id="portfolio">
            <div className="container mt-5">
                <h2>Portfolio</h2>
                <div className="row">
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${Banner})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> Online Recruitment
                                    Portal
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    BOOTSTRAP, JQUERY, PHP, MYSQL
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://github.com/coolheaded1/recruitment-portal"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-github"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${Splash})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> Github Profile
                                    Finder(mobile)
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    REACT-NATIVE, EXPO, GITHUB API
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://expo.io/@coolheaded/GitFinder"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${Netflix})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> Netflix Clone
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    REACT, NETFLIX API, BOOTSTRAP, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://netflix-klon.netlify.app/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${GitFinder})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> GitHub Profile
                                    Finder (web)
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    REACT, GITHUB API, BOOTSTRAP, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://findmyrepo.netlify.app/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${Chatty})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> Group Chat App
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    REACT, FIREBASE, BOOTSTRAP, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://group-chatt-app.netlify.app/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${News})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> NEWS APP
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    REACT, FIREBASE, BOOTSTRAP, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Frontend &amp;
                                    Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://github.com/coolheaded1/news-app"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-github"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{
                                    backgroundImage: `url(${Investment})`,
                                }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> INVESTMENT PLATFORM
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    BOOTSTRAP, PHP, MYSQL, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://bluestandard.ng"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{ backgroundImage: `url(${Shopping})` }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> SHOPPING PLATFORM
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    BOOTSTRAP, PHP, MYSQL, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://stikoglobalventures.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 col-12">
                        <div className="grid">
                            <div
                                className="grid_image"
                                style={{
                                    backgroundImage: `url(${Owolabi})`,
                                    backgroundSize: "contain",
                                }}
                            />
                            <div className="mt-5">
                                <h5>
                                    <strong>Topic:</strong> FUNDS RAISING
                                    PLATFORM
                                </h5>
                                <h5>
                                    <strong>Languages &amp; Tools:</strong>{" "}
                                    BOOTSTRAP, PHP, MYSQL, JQUERY
                                </h5>
                                <h5>
                                    <strong>Role:</strong> Backend
                                </h5>
                                <h5>
                                    <strong>Live:</strong>
                                    <a
                                        href="https://owolabitwinsfoundation.org/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ml-2"
                                    >
                                        <i
                                            className="fa fa-globe"
                                            id="fafa2"
                                        ></i>
                                    </a>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
